import {RequestConfig as BaseRequestConfig, TypedRequestConfig} from '@yandex-delivery/core/utils/network'

type CacheKeyFunction = () => string

type RequestConfig = BaseRequestConfig & {cacheKey?: string | CacheKeyFunction}

type CacheItem<Data> = {
  data: Data
  timestamp: number
}

type CreateCacheMiddlewareConfig = {
  staleTime?: number
}

export function createCacheMiddleware(middlwareConfig?: CreateCacheMiddlewareConfig) {
  const {staleTime = Infinity} = middlwareConfig || {}

  return function withCache<Response>(fetchFn: (config: TypedRequestConfig) => Promise<Response>) {
    const cache: Map<string, CacheItem<Response>> = new Map()

    return function _fetchWithCache(config: RequestConfig) {
      const cacheKey = config.cacheKey
      const now = Date.now()

      if (cacheKey) {
        const key: string | undefined = typeof cacheKey === 'function' ? cacheKey() : cacheKey

        if (key) {
          const result = cache.get(key)

          if (result && now - result.timestamp <= staleTime) {
            return Promise.resolve(result.data)
          }

          return fetchFn(config).then(function _cacheResponse(data) {
            cache.set(key, {
              data,
              timestamp: now,
            })

            return data
          })
        }
      }

      return fetchFn(config)
    }
  }
}
